import { useState, useEffect } from "react";
import { useAuth } from "context/auth";

function useRoles() {
  const [auth] = useAuth();

  const roles = auth?.userDetails?.roles;
  const permissions = auth?.userDetails?.permissions;

  const [rolesDictionary, setRolesDictionary] = useState({
    employee: false,
    systemAdmin: false,
    people: false,
    manager: false,
    employeeOrManager: false,
    employeeOrPeople: false,
    systemAdminOrManager: false,
  });
  const [permissionsDictionary, setPermissionsDictionary] = useState({
    print: false,
    changeRequests: false,
  });
  const [init, setInit] = useState(false);

  useEffect(() => {
    if (roles && !init) {
      const rolesArr = roles.map((role) => role.roleId);
      const permissionsArr = permissions.map(
        (permission) => permission.permissionId
      );
      // [
      //   {
      //     id: 1,
      //     name: "employee",
      //     alias: "موظف",
      //   },
      //   {
      //     id: 2,
      //     name: "systemAdmin",
      //     alias: "مدير نظام",
      //   },
      //   {
      //     id: 3,
      //     name: "people",
      //     alias: "مسكين",
      //   },
      //   {
      //     id: 4,
      //     name: "manager",
      //     alias: "مدير",
      //   },
      // ];
      setRolesDictionary({
        employee: rolesArr.includes(1),
        systemAdmin: rolesArr.includes(2),
        people: rolesArr.includes(3),
        manager: rolesArr.includes(4),
        employeeOrManager: rolesArr.includes(1) || rolesArr.includes(4),
        employeeOrPeople: rolesArr.includes(1) || rolesArr.includes(3),
        systemAdminOrManager: rolesArr.includes(2) || rolesArr.includes(4),
      });
      //   [{
      //     id: 1,
      //     name: "Print",
      //     alias: "طباعة",
      //   },]
      // -----------------------
      // 1	PrintDraft	طباعة مخطط تجريبي
      // 2	Requests	طلبات تغيير
      // 3	PrintOfficial	طباعة مخطط رسمي
      // 4	Blueprints	تقرير إصدار مخططات
      // 6	ExportReports	تصدير تقارير
      // 7	PrintReport	طباعة تقارير
      // 8	PaymentReport	تقرير الإرسالية المالية
      // 8	DisablePdf	تعطيل مخططات
      // 11	يغير حالة الفاتورة
      // 12	يغير حالة الفاتورة
      const permissionsRegex = /4|8|6|12/g;
      setPermissionsDictionary({
        // ------------------------
        employeeWithPrintDraft:
          rolesArr.includes(1) && permissionsArr.includes(1),
        employeeWithPrintOfficial:
          rolesArr.includes(1) && permissionsArr.includes(3),
        employeeWithChangeRequests:
          rolesArr.includes(1) && permissionsArr.includes(2),
        employeeWithReports:
          rolesArr.includes(1) && !!`${permissionsArr}`.match(permissionsRegex),
        employeeWithRegulationPlansReport:
          rolesArr.includes(1) && permissionsArr.includes(4),
        employeeWithPaymentReport:
          rolesArr.includes(1) && permissionsArr.includes(8),
        employeeCanExportReport:
          rolesArr.includes(1) && permissionsArr.includes(6),
        employeeCanPrintReport:
          rolesArr.includes(1) && permissionsArr.includes(7),
        employeeCanDisablePdf:
          rolesArr.includes(1) && permissionsArr.includes(9),
        employeeCanDisablePeoplePrint:
          rolesArr.includes(1) && permissionsArr.includes(10),
        employeeCanChangePaymentStatus:
          rolesArr.includes(1) && permissionsArr.includes(11),
        employeeWithDashboardReport:
          rolesArr.includes(1) && permissionsArr.includes(12),
        // ------------------------
      });
      setInit(true);
    }
  }, [auth.userDetails]);
  return {
    roles: rolesDictionary,
    permissions: permissionsDictionary,
    initRoles: init,
  };
}

export default useRoles;
